// extracted by mini-css-extract-plugin
export var actionText = "_pn-4";
export var container = "_pn-0";
export var leftSection = "_pn-1";
export var rightSection = "_pn-2";
export var settingsButton = "_pn-6";
export var settingsIcon = "_pn-7";
export var shortcut = "_pn-5";
export var shortcutGroup = "_pn-3";